<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span>Education Payments Made Simple</div>
            <div class="banner_tips mt-40 fw-300">Focus on learners while we streamline payments. All-in-one solution built for ease, efficiency, and growth.</div>
             <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
          </div>
       </div>
    </div>
    <div class="container pb-80"> 
      <div class="page_top" >
        <div class="page_width" > 
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                  <!-- <div class="flex_col_start"> -->
                    <div class="page_title pb-30">
                      <div class="title_name color1 text-l">What We Offer</div>
                      <div class="title_tag color1 text-l">Features for educational platforms</div>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show1?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(1)">Scalable Payment Plans</div>
                        <el-collapse-transition>
                          <div class="half_text color1 fs-14 fw-300" v-show="show1">Whether you’re a small academy or a global e-learning platform, our flexible plans adapt to your needs, supporting your growth every step of the way.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show2?'active_item':'']">  
                        <div class="half_title fs-30 pointer" @click="showOne(2)">Secure Transaction Processing</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show2">Our payment gateway ensures safe, reliable transfers of financial data between learners, your platform, and banks.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show3?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(3)">AI-Powered Insights</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show3">Leverage advanced analytics to understand learner behavior and optimize your platform’s performance.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show4?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(4)">Global Banking Integration</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show4">Connect effortlessly with major banks across the UK, EU, and beyond for smooth, secure transactions.</div>
                        </el-collapse-transition>
                    </div>
                  <!-- </div> -->
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t16.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
   

    <div class="container page_title_bg py-50">
        <div class="page_width">
            <div class="page_title">
                <div class="title_name color1 ">FAQs</div>
               
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are transactions processed?" name="1">
                            <div class="coll_item">Funds are available in your account within minutes, thanks to our instant transaction technology.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Corelinkpay secure for educational platforms?" name="2">
                           <div class="coll_item">Yes, our platform uses advanced encryption and AI-powered fraud detection to ensure every transaction is protected.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I integrate CorelinkPay with my existing platform?" name="3">
                           <div class="coll_item">Absolutely! Our streamlined APIs make integration quick and easy, getting your marketplace up and running in no time.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
               

            </div>
        </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >

          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color1 text-l">Tools to Elevate Your Educational Platform</div>
                        <div class="title_tag color1 text-l">Experience the power of instant payments, intuitive APIs, and actionable analytics. Corelinkpay’s payment solutions let you focus on delivering world-class education while we handle the financial side with precision and care.</div>
                    </div>
                </div>
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t50.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    data(){
        return{
           
            activeName:'1',
            show1:true,
            show2:false,
            show3:false,
            show4:false,
        }
    },
     methods:{
      showOne(tab){
      if(this.show1 && tab == 1 || this.show2 && tab == 2 || this.show3 && tab == 3 || this.show4 && tab == 4){
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show4 = false
        return
      }
        switch (tab) {
          case 1:
            this.show1 = true
            this.show2 = false
            this.show3 = false
            this.show4 = false
            break;
          case 2:
            this.show1 = false
            this.show2 = true
            this.show3 = false
            this.show4 = false
            break;
          case 3:
            this.show1 = false
            this.show2 = false
            this.show3 = true
            this.show4 = false
            break;
          case 4:
            this.show1 = false
            this.show2 = false
            this.show3 = false
            this.show4 = true
            break;
          default:
            break;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg7.png);
}

.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.tab_group{
  padding-left:20px;
  position: relative;
  .half_title{
    color:$theme_color1;
     position: relative;
      &::before{
        content: "";
        position: absolute;
        left: -20px;
        top: 18px;
        width: 8px;
        height: 8px;
        border-left: 3px solid #dddddd;
        border-top: 3px solid #dddddd;
        transition: all 0.35s ease-in-out;
        transform: rotate(135deg);
      }
  }
 
}
.active_item{
  .half_title{
      color: $theme_color3;
      position: relative;
      &::before{
        border-left: 3px solid $theme_color3;
        border-top: 3px solid $theme_color3;
        transform: rotate(225deg);
      }
  }
   

}
</style>